import Linkify from 'linkify-it'
import tlds from 'tlds'
import { Range } from 'slate'

const defaultExtractorSelectorFilter = () => true
const MAX_URLS = 5

const linkify = Linkify()
  .tlds(tlds)
  .set({ fuzzyIP: true })

// input: [{ref, url}]
// output: [{ref, node, callback}]
export default function makeUnfurlHandler(extractors) {
  return async function unfurlHandler(
    editor,
    { insertedBlocks = [], insertedUrls = [] }
  ) {
    const defaultBlockId = editor.value.startBlock.getIn(['data', 'id'])
    const urlsToHandle = insertedBlocks.length ? [] : insertedUrls
    insertedBlocks.forEach(rawNode => {
      const referenceBlockId = rawNode.getIn(['data', 'id']) || defaultBlockId

      const node = editor.value.document.findDescendant(
        block => block.getIn(['data', 'id']) === referenceBlockId
      )

      const text = node.text
      const entities = linkify.match(text)
      if (entities) {
        const currentBlockUrls = entities.reverse().map(entity => {
          const { key: anchorKey } = node.getTextAtOffset(entity.index)
          const { key: focusKey } = node.getTextAtOffset(entity.lastIndex)

          const rawRange = {
            anchor: {
              key: anchorKey,
              path: editor.value.document.getPath(anchorKey),
              offset: entity.index - node.getOffset(anchorKey),
            },
            focus: {
              key: focusKey,
              path: editor.value.document.getPath(focusKey),
              offset: entity.lastIndex - node.getOffset(focusKey),
            },
          }

          const range = Range.create(rawRange).normalize(editor.value.document)
          return {
            url: entity.raw,
            ref: referenceBlockId,
            range,
          }
        })
        if (currentBlockUrls.length) {
          urlsToHandle.push(...currentBlockUrls)
        }
      }
    })

    if (urlsToHandle.length > MAX_URLS) {
      return null
    }

    const results = await Promise.all(
      urlsToHandle.map(
        async ({
          url,
          ref,
          bypassSuggestion = false,
          extractorsSelectorFilter = defaultExtractorSelectorFilter,
          range,
        }) => {
          const usableExtractors = extractors.filter(extractorsSelectorFilter)

          for (const extractor of usableExtractors) {
            const result = await extractor(editor, {
              url,
              bypassSuggestion,
              ref,
              range,
            })
            if (result) {
              return true
            }
          }
        }
      )
    )
    return results.some(handled => Boolean(handled))
  }
}
